"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'ads/v1';
var THIRTY_SECONDS_IN_MS = 30000;

var AdsPixelAPI =
/*#__PURE__*/
function () {
  function AdsPixelAPI() {
    (0, _classCallCheck2.default)(this, AdsPixelAPI);
  }

  (0, _createClass2.default)(AdsPixelAPI, null, [{
    key: "getPixels",
    // Generic (ie. network-agnostic) endpoint for retrieving pixels
    value: function getPixels() {
      return _apiClient.default.get(API_BASE + "/pixel", {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
  }, {
    key: "installPixel",
    value: function installPixel(_ref) {
      var adNetwork = _ref.adNetwork,
          accountId = _ref.accountId,
          id = _ref.id;
      return _apiClient.default.post(API_BASE + "/pixel/" + adNetwork.toLowerCase() + "/account/" + accountId + "/pixel/" + id, {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
  }, {
    key: "uninstallPixel",
    value: function uninstallPixel(_ref2) {
      var adNetwork = _ref2.adNetwork,
          accountId = _ref2.accountId,
          id = _ref2.id;
      return _apiClient.default.delete(API_BASE + "/pixel/" + adNetwork.toLowerCase() + "/account/" + accountId + "/pixel/" + id, {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
  }, {
    key: "createPixel",
    value: function createPixel(_ref3) {
      var adNetwork = _ref3.adNetwork,
          accountId = _ref3.accountId;
      return _apiClient.default.post(API_BASE + "/pixel/" + adNetwork.toLowerCase() + "/account/" + accountId, {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
  }]);
  return AdsPixelAPI;
}();

exports.default = AdsPixelAPI;
module.exports = exports.default;